export default "__VITE_ASSET__BI09IehU__"